// Partners (tkt-backend docs/PARTNER-PORTAL.md): organizations with the partner portal on, holding a share
// of organizers' events. A real file route, its own chunk, nothing added to the legacy $.tsx switch.
// Where there is no partner portal (lib/accessGating partnersEnabled: MoMo) the address goes to the dashboard.
import React from 'react';
import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router';
import { partnersEnabled } from '../lib/accessGating';
import { pathForRoute } from '../lib/router';
import { PartnersListPage } from '../modules/partners/PartnersListPage';

export const Route = createFileRoute('/partners/')({
  beforeLoad: () => {
    if (!partnersEnabled()) throw redirect({ to: '/', replace: true });
  },
  component: function PartnersRoute() {
    const navigate = useNavigate();
    return <PartnersListPage onSelect={(p) => p?.id && navigate({ to: pathForRoute('partner-detail', { id: p.id }) })} />;
  },
});
